import { Modul_CTA } from "@/wp/types/acf-module-types";
import { CTAModuleOptionsType } from "@/types/ModuleOptionsType";
import { Section } from "@/components/Section/Section";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import styles from "./CTA.module.scss";
import CTAText from "./CTAText/CTAText";
import CTAMedia from "./CTAMedia/CTAMedia";
import { columnSize, textColumnSize } from "@/utils/layout/columnSize";
export type CTAModuleType = Modul_CTA;

interface ModuleProps {
  data: CTAModuleType;
  CTAModuleOptions: CTAModuleOptionsType;
  //server side fetched data
}

export type BoxOptionsType = {
  show_card_box: boolean;
  show_box_shadow: boolean;
  show_border_radius: boolean;
  box_padding: {
    mobile: string;
    tablet: string;
    desktop: string;
    fullhd: string;
  };
};

const CTA = ({ data, CTAModuleOptions }: ModuleProps) => {
  const {
    id,
    row_direction_class,
    section_margin_class,
    background_color_class,
    module_width,
  } = data.layout;

  const {
    show_extended_link,
    show_overline_subline,
    button_type,
    box,
    type,
    media_format,
    media_layout,
    columns,
    columns_text,
  } = CTAModuleOptions;
  //! check if module is hidden
  if (checkModuleIsHidden(data.settings)) {
    return null;
  }
  const textColumns = textColumnSize({ columns_text, columns });

  return (
    <Section
      className={`${styles.cta} ${module_width} ${section_margin_class}`}
      columnsClassName="is-centered m-0"
      frameless={module_width === "frameless"}
      id={id}
    >
      <div
        className={`column p-0 ${module_width === "narrow-frame" ? columnSize(columns) : "is-12"}`}
      >
        <div
          className={[
            styles["cta-flex-wrapper"],
            type === "text-image"
              ? styles["has-image"]
              : `${background_color_class} ${styles["text-only"]}`,
            type === "text-image" ? row_direction_class : "",
            styles[media_layout],
          ].join(" ")}
        >
          <CTAText
            data={data}
            show_overline_subline={show_overline_subline}
            show_extended_link={show_extended_link}
            button_type={button_type}
            box={box}
            columns_text={textColumns}
            type={type}
          />
          {type === "text-image" && (
            <CTAMedia
              data={data}
              sizes="100vw"
              mediaFormat={media_format}
              box={box}
            />
          )}
        </div>
      </div>
    </Section>
  );
};

export default CTA;
